// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const def_breakpoints = {
  mob: 300,
  tblt_prt: 700,
  tblt_ls: 1000,
  desk_sm: 1200,
  desk_md: 1400,
};

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

let viewportState = {
  is_mob: false,
  is_tablet_prt: false,
  is_tablet_ls: false,
  is_desk_sm: false,
  is_desk_md: false,
};

export function init_viewportState(
  { breakpoints = def_breakpoints } = {
    breakpoints: def_breakpoints,
  }
) {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Function to get stable viewport width
  const getStableViewportWidth = () => {
    // Try multiple methods to get most accurate width
    const methods = [() => window.innerWidth, () => document.documentElement.clientWidth, () => document.body.clientWidth];

    // Use the first available method that returns a reasonable value
    for (const method of methods) {
      try {
        const width = method();
        if (width && width > 0) return width;
      } catch (e) {
        continue;
      }
    }
    return window.innerWidth; // fallback
  };

  // Function to update viewport state
  const updateViewportState = () => {
    const w_viewport = getStableViewportWidth();
    console.log("Viewport width:", w_viewport);

    viewportState = {
      is_mob: w_viewport < breakpoints.tblt_prt,
      is_tablet_prt: w_viewport >= breakpoints.tblt_prt && w_viewport < breakpoints.tblt_ls,
      is_tablet_ls: w_viewport >= breakpoints.tblt_ls && w_viewport < breakpoints.desk_sm,
      is_desk_sm: w_viewport >= breakpoints.desk_sm,
      is_desk_md: w_viewport >= breakpoints.desk_md,
    };

    return w_viewport;
  };

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Use requestAnimationFrame for more stable viewport detection
  const initWithStableViewport = () => {
    requestAnimationFrame(() => {
      const initialWidth = updateViewportState();

      // Double-check after another frame for responsive design mode
      requestAnimationFrame(() => {
        const secondWidth = getStableViewportWidth();

        // If width changed significantly, update again
        if (Math.abs(initialWidth - secondWidth) > 10) {
          console.log("Viewport width changed, updating:", secondWidth);
          updateViewportState();
        }
      });
    });
  };

  // Initialize
  initWithStableViewport();

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // ...
}

export function get_viewportState() {
  return viewportState;
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
